import {
  type CustomizationDataQuery,
  type CustomizationDataQueryVariables,
  type CustomizationEditDataQuery,
} from '../../graphql/CustomizationData.generated';

// ─── Customization Data ──────────────────────────────────────────────────────

export type CustomizationDataInput = {
  productSlug: CustomizationDataQueryVariables['productId'];
  restaurantSlug: CustomizationDataQueryVariables['restaurantId'];
  lineItemId: string | undefined;
  ingredientAssetVersion: CustomizationDataQueryVariables['ingredientAssetVersion'];
};

export type EditCustomizationDataInput = {
  productSlug: CustomizationDataQueryVariables['productId'];
  restaurantSlug: CustomizationDataQueryVariables['restaurantId'];
  lineItemId: string;
  ingredientAssetVersion: CustomizationDataQueryVariables['ingredientAssetVersion'];
};

export type CustomizationDataResponse = {
  product: Product;
  lineItem?: ProductLineItem;
  restaurant: ProductRestaurant;
};

// ─────────────────────────────────────────────────────────────────────────────

export type ProductModification = ProductModifierGroup['modifications'][number];
export type ProductModifierGroup = ProductModifierGroups[number];
export type ProductModifierGroups = Product['modifierGroups'];

export type Product = CustomizationDataQuery['product'];
export type ProductIngredients = Product['ingredients'];
export type ProductRestaurant = CustomizationDataQuery['restaurant'];
export type ProductLineItem = Extract<
  CustomizationEditDataQuery['lineItem'],
  { __typename: 'LineItemSuccess' }
>['lineItem'];

export type ProductIngredientAssetVersion =
  CustomizationDataQueryVariables['ingredientAssetVersion'];
